import { render, staticRenderFns } from "./LeaseAreas.vue?vue&type=template&id=007af9d6&lang=html&"
import script from "./LeaseAreas.vue?vue&type=script&lang=js&"
export * from "./LeaseAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports